import { AppBar, Toolbar, Tab, Tabs } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { label: 'Drivers', path: '/drivers' },
  { label: 'Businesses', path: '/businesses' },
  { label: 'Government', path: '/government' },
];

const TopBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeTab = tabs.findIndex((t) => pathname.startsWith(t.path));

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: 'white',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar variant="dense" sx={{ justifyContent: 'center', minHeight: 48 }}>
        <Tabs value={activeTab === -1 ? false : activeTab} textColor="primary" indicatorColor="primary">
          {tabs.map((tab) => (
            <Tab
              key={tab.path}
              label={tab.label}
              onClick={() => navigate(tab.path)}
              disabled={tab.path !== '/drivers'}
            />
          ))}
        </Tabs>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
